import { Menu, MenuItem } from '@mui/material';
import { setTransportSelectedItemConditionOptions } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapTransportTrackIntervalMenu = ({ open, onClose, anchorEl }) => {
    var _a;
    const dispatch = useDispatch();
    const { conditionOptions } = (_a = useSelector((state) => state.map.transportSelectedItem)) !== null && _a !== void 0 ? _a : {};
    const formatInterval = (hour) => {
        moment.relativeTimeThreshold('h', 25);
        return `${hour > 1 ? '' : '1 '}${moment.duration(hour, 'hours').humanize()}`;
    };
    const handleTrackIntervalClick = (value) => {
        dispatch(setTransportSelectedItemConditionOptions(Object.assign(Object.assign({}, conditionOptions), { interval: value })));
        onClose();
    };
    return (React.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: onClose, PaperProps: {
            sx: {
                minWidth: '140px',
                marginTop: '1px',
                '&:before': {
                    display: 'none',
                },
            },
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, config.mapTransportTrackInterval.map((value, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, selected: (conditionOptions === null || conditionOptions === void 0 ? void 0 : conditionOptions.interval) === value, onClick: () => handleTrackIntervalClick(value) }, formatInterval(value))))));
};
export default MapTransportTrackIntervalMenu;
